module.exports = __webpack_public_path__ + "static/img/home_2.e8020c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/home_2.png
// module id = nGUj
// module chunks = 4